import { render, staticRenderFns } from "./SpecialistBuildingDistibutionPage.vue?vue&type=template&id=75847360&"
import script from "./SpecialistBuildingDistibutionPage.vue?vue&type=script&lang=js&"
export * from "./SpecialistBuildingDistibutionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports